import { useDispatch, useSelector } from "react-redux";
import { clearAddressAndCost } from "../modules/delivery/actions";
import { deliveryAvailableSelector } from "../modules/delivery/selectors";
import { ClickableDiv } from "../styles";
import { formatPrice } from "../utils/format";
import SearchLocationForm from "./searchLocationForm";

function AddressDelivery() {
  const dispatch = useDispatch();
  const { address, cost, distance } = useSelector((state) => state.delivery);
  const deliveryAvailable = useSelector(deliveryAvailableSelector);

  return (
    <div className="delivery-address-section">
      <div className="delivery-address-heading">
        <div>
          <span className="interface-label">Trasa dostawy</span>
          <strong>
            {address ? "Pod wskazany adres" : "Dokąd dostarczyć?"}
          </strong>
        </div>
        {address && (
          <ClickableDiv
            as="button"
            type="button"
            className="delivery-address-change"
            onClick={() => dispatch(clearAddressAndCost())}
          >
            Zmień
          </ClickableDiv>
        )}
      </div>
      {address ? (
        <div className="delivery-address-card">
          <div className="delivery-route-marker" aria-hidden="true">
            <span />
            <i />
            <span />
          </div>
          <div className="delivery-address-content">
            <div className="delivery-address-label">Adres odbiorcy</div>
            <div className="delivery-address-value">{address}</div>
            {deliveryAvailable && (
              <div className="delivery-address-meta">
                <span>Dostarczymy tutaj</span>
                {distance !== null && (
                  <span className="delivery-distance">
                    {Number(distance).toFixed(1)} km
                  </span>
                )}
                <strong>{formatPrice(cost)} zł</strong>
              </div>
            )}
            {!deliveryAvailable && (
              <div className="delivery-address-meta delivery-address-meta--error">
                Poza obszarem dowozu
              </div>
            )}
          </div>
        </div>
      ) : (
        <SearchLocationForm />
      )}
    </div>
  );
}

export default AddressDelivery;
